import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, Modal, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import PRINT_RECEIPT from './Print_Receipt';
import PRINT_FEECARD from './Print_Fee_Card';
import ViewRcptModal from './ViewRcptModal';
//import SearchRcptModal from './SearchRcptModal';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

const FeesCollection = () => {

  const [headerData, setHeaderData] = useState({
    receipt_no: "",
    receipt_date: new Date().toISOString().split("T")[0],
    academic_years: "",
    year1: "",
    year2: "",
    section_id: "",
    gr_no: "",
    stud_name: "",
    std_id: "",
    div_id: "",
    std_name: "",
    div_name: "",
    receipt_status: "NEW",
    from_installment: "",
    to_installment: "",
    from_install_name: "",
    to_install_name: "",
    total_fees: "0.00",
    amt_received: "0.00",
    amt_returned: "0.00",
    amt_waived: "0.00",
    fee_waiver_id: "",
    fee_waiver_name: "",
    payment_mode: "CASH",
    instrument_no: "",
    narration: "",
    stud_pic: "",
    terms: "",
  });

  const [childRows, setChildRows] = useState([
    {
      fee_code: "",
      fee_desc: "",
      install_no: "",
      minInstall: "",
      maxInstall: "",
      minInstallName: "",
      maxInstallName: "",
      install_name: "",
      fee_amt: "",
      waiver_amt: "",
      net_amt: "",
    },
  ]);

  const [schoolDetails, setSchoolDetails] = useState({
    schoolName: "",
    schoolAddr1: "",
    schoolAddr2: "",
    schoolPhone1: "",
    email_id: "",
    website: "",
    logoPath: "",
    preparedBy: ""
  });

  const [isGRFound, setIsGRFound] = useState(false);
  const [ddlSections, setDdlSections] = useState([]);
  const [ddlGRNos, setDdlGRNos] = useState([]);
  const [ddlFromMonths, setDdlFromMonths] = useState([]);
  const [ddlToMonths, setDdlToMonths] = useState([]);
  const [feesData, setFeesData] = useState([]);
  const [errors, setErrors] = useState({});
  const [showRcptPrint, setShowRcptPrint] = useState(false);
  const [resetAfterClose, setResetAfterClose] = useState(false);
  const [editingRow, setEditingRow] = useState(null);

  const [showFeeCardPrint, setShowFeeCardPrint] = useState(false);
  const [feeStructData, setFeeStructData] = useState([]);
  const [installTotData, setInstallTotData] = useState([]);
  const [feeRecordData, setFeeRecordData] = useState([]);
  const [termsData, setTermsData] = useState([]);
  const [studPicData, setStudPicData] = useState([]);
  const [showsearchModal, setShowSearchModal] = useState(false);

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

    } catch (err) {
      console.error(err);
    }

  };

  const handleHeaderChange = async (e) => {

    const { name, value } = e.target;

    if (name === "section_id") {
      setIsGRFound(false);
      setDdlGRNos([]);
      setFeesData([]);
      setDdlFromMonths([]);
      setDdlToMonths([]);
      setHeaderData(prev => ({ ...prev,
        section_id: value,
        gr_no: "",
        stud_name: "",
        std_name: "",
        year1: "",
        year2: "",
        academic_years: "",
        from_installment: "",
        to_installment: "",
        from_install_name: "",
        to_install_name: "",
        fee_waiver_name: "",
        std_id: "",
        div_id: "",
        fee_waiver_id: "" ,
        stud_pic: "",
        terms: ""}));
      setChildRows([{ fee_code: "", fee_desc: "", install_no: "", minInstall: "", maxInstall: "", minInstallName: "", maxInstallName: "",
                      install_name: "", fee_amt: "", waiver_amt: "", net_amt: ""}]);
    //  let updatedData = {...headerData, [name]: value, };
      if (value || value !== '') {
        const studResponse = await axios.get(`${BASE_URL}/api/ddl_stud_name_gr`,
          { params: { p_Section_Id: value } });
        setDdlGRNos(studResponse.data);
      }
      //setHeaderData({section_id: value});
    } else if (name === "amt_received") {
      let updatedData = {...headerData, [name]: value, };
      const received = parseFloat(value || 0);
      const total = parseFloat(headerData.total_fees || 0);
      updatedData.amt_returned = received > total ? (received - total).toFixed(2) : "0.00";
      setHeaderData(updatedData);
    } else {
      let updatedData = {...headerData, [name]: value, };
      setHeaderData(updatedData);
    }

    setErrors({});

  };

  const handleAmtRcvdBlur = async (e) => {
    const { name, value } = e.target;

    let lv_amt = parseFloat(value.replace(/,/g, ''));

    let updatedData = {
      ...headerData,
      [name]: formatAmount(lv_amt),
    };

    setHeaderData(updatedData);

  }

  const handleToInstallChange = async (e) => {

    const { name, value } = e.target;
    const to_install_name = e.target.options[e.target.selectedIndex].text;

    let updatedData = {
      ...headerData,
      [name]: value,
      to_install_name: to_install_name
    };

    setHeaderData(updatedData);

    setChildRows([]);
    const result = getFeeSummary(feesData, e.target.value);
    setChildRows(result);

  }

  const handleGrChange = (selectedOption) => {

    try {

      setHeaderData(prev => ({
        ...prev,
        gr_no: selectedOption ? selectedOption.value : "",
        stud_name: selectedOption ? selectedOption.label : ""
      }));

      retrieveFeeDetails(headerData.section_id, selectedOption.value);

    } catch (e) {
      toast.error('Unable to retrieve fees data.');
    }

  };

  const retrieveFeeDetails = async (p_section_id, p_gr_no) => {

    try {
      const studResponse = await axios.get(`${BASE_URL}/api/get_balance_fees_byGRNo`,
        { params: { p_Section_Id: p_section_id, p_GR_No: p_gr_no } });

      if (!studResponse.data.headerFrom) {
        toast.error('Fees Not pending for the entered GR No. ' + p_gr_no);
        return;
      } else {
        setIsGRFound(true);
        setHeaderData(prev => ({
          ...prev,
          std_name: studResponse.data.headerFrom.std_div,
          std_id: studResponse.data.headerFrom.std_id,
          div_id: studResponse.data.headerFrom.div_id,
          year1: studResponse.data.headerFrom.year1,
          year2: studResponse.data.headerFrom.year2,
          academic_years: studResponse.data.headerFrom.year1 + '-' + studResponse.data.headerFrom.year2,
          from_installment: studResponse.data.headerFrom.from_inst_no,
          from_install_name: studResponse.data.headerFrom.from_inst_name,
          fee_waiver_name: studResponse.data.headerFrom.fee_waiver_name,
          fee_waiver_id: studResponse.data.headerFrom.fee_waiver_id,
          to_installment: studResponse.data.toMonths[0].to_install_no,
          to_install_name: studResponse.data.toMonths[0].to_install_name,          
        }));
        setDdlFromMonths(studResponse.data.headerFrom);
        setDdlToMonths(studResponse.data.toMonths);
        setFeesData(studResponse.data.details);
        const result = getFeeSummary(studResponse.data.details, studResponse.data.toMonths[0].to_install_no);
        setChildRows(result);
       // Inst_Dtl_Rcpt_Print();
        prepare_FeeCardData(studResponse.data.headerFrom.year1, studResponse.data.headerFrom.std_id, p_section_id, p_gr_no);
      }

    } catch (error) {
      toast.error('Unable to retrieve fees data. : ' + error);
    }

  }

  const Inst_Dtl_Rcpt_Print = async (p_fee_rcpt_no) => {

    try {

      const response = await axios.get(`${BASE_URL}/api/get_inst_rcpt_print`, {
        params: { p_Sect_Id: headerData.section_id, p_rcpt_no: p_fee_rcpt_no }
      });

      if (response.data.length > 0) {
        setSchoolDetails({
          schoolName: response.data[0].inst_name,
          schoolAddr1: response.data[0].addr_1,
          schoolAddr2: response.data[0].addr_2,
          schoolPhone1: response.data[0].tel_no,
          email_id: response.data[0].email_id,
          website: response.data[0].website,
          logoPath: response.data[0].logo_path,
          preparedBy: response.data[0].user_name
        });
      }

      return true;

    } catch (err) {
      console.error(err);
      return false;
    }

  };

  const getFeeSummary = (data, toInstallment) => {
    // Filter installments in selected range
    const filtered = data.filter(
      item => Number(item.install_no) <= Number(toInstallment)
    );

    // Group and sum by fee_code
    const grouped = filtered.reduce((acc, curr) => {
      const installNo = Number(curr.install_no);

      if (!acc[curr.fee_code]) {
        acc[curr.fee_code] = {
          fee_code: curr.fee_code,
          fee_desc: curr.fee_desc,
         // waiver_amt: curr.waiver_amt,
          waiver_amt: 0,
          fee_amt: 0,
          minInstall: Number(curr.install_no),
          maxInstall: Number(curr.install_no),
          minInstallName: curr.install_name,
          maxInstallName: curr.install_name,
          sort_order: curr.sort_order,
          net_amt: 0
        };
      }

      acc[curr.fee_code].fee_amt += Number(curr.fee_amt);
      acc[curr.fee_code].waiver_amt += Number(curr.waiver_amt || 0);
      acc[curr.fee_code].net_amt += Number(curr.fee_amt) - Number(curr.waiver_amt || 0);

      if (installNo < acc[curr.fee_code].minInstall) {
        acc[curr.fee_code].minInstall = installNo;
        acc[curr.fee_code].minInstallName = curr.install_name;
      }

      if (installNo > acc[curr.fee_code].maxInstall) {
        acc[curr.fee_code].maxInstall = installNo;
        acc[curr.fee_code].maxInstallName = curr.install_name;
      }

      return acc;
    }, {});

    return Object.values(grouped).map(item => ({
      ...item,
      install_name:
        item.minInstall === item.maxInstall
          ? item.minInstallName
          : `${item.minInstallName}|${item.maxInstallName}`
    }));

  };

  useEffect(() => {

    const totalFees = childRows.reduce((sum, row) => sum + (parseFloat(row.fee_amt) || 0), 0);
    const totalWaived = childRows.reduce((sum, row) => sum + (parseFloat(row.waiver_amt) || 0), 0);

    const totalDueFees = totalFees - totalWaived;

    setHeaderData(prev => ({ ...prev, total_fees: totalDueFees, amt_waived: totalWaived }));

  }, [childRows]);

  const resetPage = () => {

      setIsGRFound(false);
      setDdlGRNos([]);
      setFeesData([]);
      setDdlFromMonths([]);
      setDdlToMonths([]);
      setHeaderData({ receipt_no: "", receipt_date: new Date().toISOString().split("T")[0], academic_years: "", year1: "", year2: "", 
                      section_id: "", gr_no: "", stud_name: "", std_name: "", div_name: "", receipt_status: "NEW", from_installment: "", 
                      to_installment: "", total_fees: "0.00", amt_received: "0.00", amt_returned: "0.00", amt_waived: "0.00", 
                      from_install_name: "", to_install_name: "",
                      fee_waiver_name: "", payment_mode: "CASH", instrument_no: "", narration: "", std_id: "", div_id: "", fee_waiver_id: ""});
      setChildRows([{ fee_code: "", fee_desc: "", install_no: "", minInstall: "", maxInstall: "", minInstallName: "", maxInstallName: "",
                      install_name: "", fee_amt: "", waiver_amt: "", net_amt: ""}]);

  }

  const handleClear = () => {

    if (window.confirm("Clear the Record ?")) {
      resetPage();
    }

  }

  const handleSave = async () => {

    const newErrors = {};

    let lv_amt_rcvd = headerData.amt_received;

    if (!headerData.amt_received || headerData.amt_received === 0 ) {
      newErrors.amt_received = 'Error';
      toast.error('Please enter Amount Received.');
    } else if (headerData.amt_received < 0 || parseFloat(lv_amt_rcvd.replace(/,/g, '')) < headerData.total_fees) {
      newErrors.amt_received = 'Error';
      toast.error('Amount Received must be greater than Total Fees Amount.');
    } else if (headerData.payment_mode === 'CHQ' && !headerData.instrument_no) {
      newErrors.instrument_no = 'Error';
      toast.error('For Payment Mode Cheque, Instrument No. must be entered.');
    } 

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus(); // 🔥 bonus (cursor goes there)
        }
      }
      return;
    }

    try {

      if (window.confirm("Save the Receipt ?")) {
        const feesReceiptData = {
          header: headerData,
          details: childRows,
        };
        const response = await axios.post(`${BASE_URL}/api/save_fee_receipt`, feesReceiptData);
        if (response.data.message !== '0') {
          setHeaderData((prev) => ({...prev, receipt_no: response.data.message}));
          toast.success('Fees Receipt No. ' + response.data.message + ' saved successfully.');
          Inst_Dtl_Rcpt_Print(response.data.message);
          setResetAfterClose(true); 
          setShowRcptPrint(true);
          //resetPage();
        } else {
          toast.error(`Unable to save receipt.`)
        }
      }

    } catch (error) {
      toast.error('Unable to Save Receipt. ' + error);
    }

  }

  const handleWaiverChange = (index, e) => {
    let { name, value } = e.target;

    value = value.replace(/,/g, "");

    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    const updated = [...childRows];

    const feeAmt = parseFloat(updated[index].fee_amt || 0);
    const waiverAmt = parseFloat(value || 0);

    updated[index] = {
      ...updated[index],
      [name]: value,
      net_amt: (feeAmt - waiverAmt),
    };

    setChildRows(updated);
  };

  const handleWaiverBlur = (index, e) => {

    const { name, value } = e.target;

    if (value === "") return;

    // ✅ Convert to number and truncate instead of round
    let numericValue = parseFloat(value.replace(/,/g, ""));
    if (isNaN(value)) return;

    // Truncate to two decimals (no rounding)
    numericValue = Math.trunc(numericValue * 100) / 100;

    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(numericValue));

    const updated = [...childRows];
    updated[index][name] = formatted;
    setChildRows(updated);

  };

  const totalFeeAmount = childRows.reduce((total, row) => {

    // remove commas and convert to number
    const amount = parseFloat(
      String(row.fee_amt || "0").replace(/,/g, "")
    );

    if (isNaN(amount)) return total;

    return total + (amount);

  }, 0);

  const handleReceiptClose = () => {

    setShowRcptPrint(false);

    if (resetAfterClose) {
      resetPage();
      setResetAfterClose(false);
    }

  };

  const prepare_FeeCardData = async(p_year1, p_std_id, p_section_id, p_gr_no) => {

    const feesCardRes = await axios.get(`${BASE_URL}/api/get_fees_card_details`,
      { params: { p_year1: p_year1, p_std_id: p_std_id, 
                  p_section_id: p_section_id, p_gr_no: p_gr_no } });

    if (feesCardRes.data.fsData) {
      setFeeStructData(feesCardRes.data.fsData);
      setInstallTotData(feesCardRes.data.installAmtData);
      setFeeRecordData(feesCardRes.data.feeRecData);
      setHeaderData(prev => ({
          ...prev,
          stud_pic: feesCardRes.data.studPicData.stud_pic,
          terms: feesCardRes.data.termsData.terms,
        }));
    }

  }

  const handleFeeCard = async () => {

    setShowFeeCardPrint(true);

  };

  const handleFeeCardClose = () => {

    setShowFeeCardPrint(false);

    if (resetAfterClose) {
      resetPage();
      setResetAfterClose(false);
    }

  };

  const totalFWAmount = childRows.reduce((total, row) => {
    // remove commas and convert to number
    const amount = parseFloat(
      String(row.waiver_amt || "0").replace(/,/g, "")
    );

    if (isNaN(amount)) return total;

    return total + (amount);

  }, 0);

  const formatAmount = (amount) =>

    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const handleRcptRowSelect = async (selRow) => {

    setShowSearchModal(false);

    const response = await axios.get(`${BASE_URL}/api/get_fee_rcpt_ById`, {
            params: {p_section_id: selRow.section_id, p_rcpt_no: selRow.rcpt_no},
          });

    headerData.receipt_no = selRow.rcpt_no;
    headerData.receipt_date = response.data.fr_headerData[0].rcpt_date;
    headerData.year1 = response.data.fr_headerData[0].year1;
    headerData.year2 = response.data.fr_headerData[0].year2;
    headerData.academic_years = headerData.year1 + '-' + headerData.year2;
    headerData.receipt_status = response.data.fr_headerData[0].status;

    headerData.section_id = selRow.section_id;

    const studResponse = await axios.get(`${BASE_URL}/api/ddl_stud_name_gr`,
      { params: { p_Section_Id: selRow.section_id } });

    setDdlGRNos(studResponse.data);

    headerData.gr_no = response.data.fr_headerData[0].gr_no;
    headerData.stud_name = response.data.fr_headerData[0].stud_name;

    headerData.std_id = response.data.fr_headerData[0].std_id;
    headerData.div_id = response.data.fr_headerData[0].div_id;
    headerData.std_name = response.data.fr_headerData[0].std_div;
//    headerData.div_name = response.data.fr_headerData[0].div_name;

    headerData.amt_received = response.data.fr_headerData[0].amt_rcvd;
    headerData.amt_returned = response.data.fr_headerData[0].amt_refund;
    headerData.amt_waived = response.data.fr_headerData[0].total_fw_amt;
    //headerData.fee_waiver_id = response.data[0].rcpt_date;
    headerData.fee_waiver_name = response.data.fr_headerData[0].fw_desc;
    headerData.payment_mode = response.data.fr_headerData[0].payment_mode;
    headerData.instrument_no = response.data.fr_headerData[0].instr_no;
    headerData.narration = response.data.fr_headerData[0].remarks;

    headerData.from_installment = response.data.fr_headerData[0].from_inst_no;
    headerData.from_install_name = response.data.fr_headerData[0].from_inst_name;

    headerData.to_installment = response.data.fr_headerData[0].to_install_no;
    headerData.to_install_name = response.data.fr_headerData[0].to_install_name;

    setDdlFromMonths(response.data.fr_headerData[0]);
    setDdlToMonths(response.data.fr_headerData);

    setChildRows(response.data.details);

    prepare_FeeCardData(response.data.fr_headerData[0].year1, response.data.fr_headerData[0].std_id,
      selRow.section_id, response.data.fr_headerData[0].gr_no);

   // handleBlur();

    // const detailRows = response.data.filter(row => Number(row.acct_code) > 0);

    // if (detailRows.length > 0) {
    //   setDetailRows(detailRows);
    // }

    // for (let i = 0; i < detailRows.length; i++) {

    //   const formatted = new Intl.NumberFormat("en-IN", {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    //   }).format(parseFloat(detailRows[i].amount));

    //   const updated = [...detailRows];
    //   updated[i]["amount"] = formatted;

    //   setDetailRows(updated);

    // }

    Inst_Dtl_Rcpt_Print(selRow.rcpt_no);

//    setIsEditable(true); 
//    setIsEditMode(true);

  };

  /// Popupating Select Dropdown list
  const grNoOptions = ddlGRNos.map(code => ({
    value: String(code.gr_no),
    label: code.stud_name
  })) || [];


  return (
    <Container fluid className="p-3">

      {/* Header Card */}
      <Card className="mb-3 p-3">

        <Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Receipt No
              </InputGroup.Text>

              <input className="form-control" value={headerData.receipt_no} disabled />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Receipt Date
              </InputGroup.Text>

              <input type="date" name="receipt_date" className="form-control" disabled={headerData.receipt_no}
                value={headerData.receipt_date} onChange={handleHeaderChange} />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}> Academic Year
              </InputGroup.Text>

              <input className="form-control" value={headerData.academic_years} disabled />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}> Receipt Status
              </InputGroup.Text>

              <input className="form-control" value={headerData.receipt_status} disabled />
            </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "80px", backgroundColor: "rgba(255, 165, 0, 0.8)" }}> Section 
              <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>

              <select className="form-select" name="section_id" disabled={headerData.receipt_no}
                value={headerData.section_id} onChange={handleHeaderChange} >
                <option value="">Select</option>
                {ddlSections.map(s => (
                  <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={9}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px", backgroundColor: "rgba(255, 165, 0, 0.8)" }}>
                Name / GR <span style={{ color: "red" }}>&nbsp;*</span>
              </InputGroup.Text>

              <div style={{ flex: 1 }}>
                {/* <Select placeholder="Search GR No./ Student Name ..." /> */}
                <Select name="gr_no"  isDisabled={headerData.receipt_no}
                  styles={{ singleValue: (provided) => ({ ...provided, color: "blue", }), }}
                  options={grNoOptions}
                  value={grNoOptions.find(option => String(option.value) === String(headerData.gr_no)) || null}
                  onChange={handleGrChange} placeholder="Search by GR No / Student name ..." />
              </div>
            </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "110px" }}> From Period
              </InputGroup.Text>

              <select className="form-control" value={headerData.from_installment} disabled> 
                {ddlFromMonths && (
                  <option value={ddlFromMonths.from_inst_no} > {ddlFromMonths.from_inst_name}
                  </option>
                )}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text 
                style={{ width: "90px", backgroundColor: "rgba(255, 165, 0, 0.8)" }}> To Period 
                    <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>

              <select className="form-select" name="to_installment"
                value={headerData.to_installment} onChange={handleToInstallChange} disabled={headerData.receipt_no} >
                {ddlToMonths.map(s => ( <option key={s.to_install_no} value={s.to_install_no}>{s.to_install_name}</option> ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}> Std / Div
              </InputGroup.Text> 
              <input className="form-control" value={headerData.std_name} disabled />
            </InputGroup>
          </Col>

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "70px" }}> Waiver
              </InputGroup.Text>

              <input className="form-control" value={headerData.fee_waiver_name} disabled />
            </InputGroup>
          </Col>

        </Row>

        {/* Summary Strip */}

        <Card className="bg-light p-3 mb-2">

          <Row>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text 
                 style={{ backgroundColor: "rgba(255, 165, 0, 0.8)" }}> Amt Received<span style={{ color: "red" }}>*</span>
                </InputGroup.Text>

                <input type="text" name="amt_received" style={{textAlign: "right"}} disabled={headerData.receipt_no}
                  value={headerData.amt_received} className={`form-control ${errors.amt_received ? "is-invalid" : ""}`}
                  onChange={handleHeaderChange} onBlur={handleAmtRcvdBlur} />
              </InputGroup>
            </Col>

            <Col md={3}>
              <div className="d-flex align-items-center justify-content-between rounded p-1"
                 style={{ border: "1px solid black" }}>
                <span style={{ fontSize: "16px" }}><b>Amt To Return :</b></span>
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>{formatAmount(headerData.amt_returned)}
                </span>
              </div>
            </Col>

            <Col md={3}>
              <div className="d-flex align-items-center justify-content-between rounded p-1" 
                   style={{ border: "1px solid maroon" }}>
                <span style={{ fontSize: "16px", color: "maroon" }}><b>Total Waived Amt :</b></span>
                <span style={{ fontSize: "18px", fontWeight: "bold", color: "maroon" }}>{formatAmount(headerData.amt_waived)}
                </span>
              </div>
            </Col>

            <Col md={3}>
            {/* border */}
              <div className="d-flex align-items-center justify-content-between  rounded p-1"
                 style={{ border: "1px solid green" }}>
                <span style={{ color: "green" }}><b>Total Net Amount :</b></span>
                <span style={{ fontSize: "18px", fontWeight: "bold", color: "green" }}> {formatAmount(headerData.total_fees)}
                </span>
              </div>
            </Col>

          </Row>

        </Card>

        <Row className="mb-3"> 

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}> Payment Mode
              </InputGroup.Text>

              <select className={`form-select ${errors.payment_mode ? "is-invalid" : ""}`} 
              name="payment_mode" value={headerData.payment_mode} 
              onChange={handleHeaderChange} disabled={headerData.receipt_no} >
                <option value="CASH">Cash</option>
                <option value="CHQ">Cheque/DD</option>
                <option value="NEFT">NEFT/IMPS</option>
                <option value="OL">Online</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Instrument
              </InputGroup.Text>

              <input className="form-control" name="instrument_no" disabled={headerData.receipt_no}
                value={headerData.instrument_no}
                onChange={handleHeaderChange} />
            </InputGroup>
          </Col>

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Remarks
              </InputGroup.Text>

              <input className="form-control" name="narration" disabled={headerData.receipt_no}
                value={headerData.narration} onChange={handleHeaderChange} />
            </InputGroup>
          </Col>

        </Row>

        <div className="d-flex justify-content-end gap-2 flex-wrap">

          <Button variant="success" style={{width:"135px"}} disabled={!isGRFound} onClick={handleSave} > Save
          </Button>

          <Button variant="warning" style={{width:"135px"}} disabled={isGRFound}
              onClick={(e) => (setShowSearchModal(true))}> View </Button>
          {showsearchModal && (
            <ViewRcptModal
              show={showsearchModal}
              handleClose={() => setShowSearchModal(false)}
              onRowSelect={handleRcptRowSelect} 
              />
          )}


          <Button variant="primary" style={{width:"135px"}} disabled={!headerData.receipt_no}
            onClick={() => { setResetAfterClose(false);   // View only
                            setShowRcptPrint(true);}} > Receipt
          </Button>
          {showRcptPrint && (
            <Modal show={showRcptPrint}
               onHide={handleReceiptClose} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Print Receipt</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PRINT_RECEIPT
                  schoolDetails={schoolDetails}
                  headerData={headerData} 
                  detailRows={childRows}
                  //onAfterPrint={() => {setTimeout(() => { setShowRcptPrint(false); resetPage();}, 1000);}}
                  onAfterPrint={() => { setTimeout(() => { handleReceiptClose(); }, 1000); }}
                />
              </Modal.Body>
            </Modal>
          )}

          <Button variant="info" style={{width:"135px"}}  disabled={!headerData.receipt_no} onClick={handleFeeCard} > Fee Card
          </Button>
          {showFeeCardPrint && (
            <Modal show={showFeeCardPrint}
               onHide={handleFeeCardClose} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Print Fee Card</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PRINT_FEECARD
                  schoolDetails={schoolDetails}
                  headerData={headerData} 
                  feeStructData={feeStructData}
                  installTotData={installTotData}
                  feeRecordData={feeRecordData}
                  onAfterPrint={() => { setTimeout(() => { handleFeeCardClose(); }, 1000); }}
                />
              </Modal.Body>
            </Modal>
          )}

          <Button variant="secondary" style={{width:"135px"}} onClick={handleClear}> Clear
          </Button>

        </div>

      </Card>

      {/* Details Card */}

      <Card className="p-3">

        <div style={{ minHeight: '220px' }}  className="table-responsive">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead>

              <tr>
                <th style={{ width: '4%', textAlign: 'center' }}>#</th>
                <th style={{ width: '28%', textAlign: 'left' }}>Fees Description</th>
                <th style={{ width: '10%', textAlign: 'center' }}>Period</th>
                <th style={{ width: '10%', textAlign: "right" }}>Fees Amount</th>
                <th style={{ width: '10%', textAlign: "right" }}>Waived Amount</th>
              </tr>

            </thead>

            <tbody>

              {childRows.map((row, index) => (

                <tr key={index}>

                  <td style={{ width: "4%", textAlign: 'center' }}>{index + 1}</td>

                  <td style={{ textAlign: 'left' }}>{row.fee_desc} </td>
                  {/* <td style={{ textAlign: 'center' }}> 
                    {row.install_name.includes("|") ? (
                      <>
                        {row.install_name.split("|")[0]}  - &nbsp; 
                        {row.install_name.split("|")[1]}
                      </>
                    ) : (
                      row.install_name
                    )}
                  </td> */}
                  <td style={{ textAlign: 'center' }}>
                    {row.install_name ? (
                      row.install_name.includes("|") ? (
                        <>
                          {row.install_name.split("|")[0]} - &nbsp;
                          {row.install_name.split("|")[1]}
                        </>
                      ) : (
                        row.install_name
                      )
                    ) : (
                      ''
                    )}
                  </td>
                  <td style={{ textAlign: 'right' }}>{formatAmount(row.fee_amt)}</td>

                  <td>
                    <input type="text"
                      name="waiver_amt"
                      className="form-control text-end"
                      style={{ textAlign: "right" }}
                      disabled={headerData.fee_waiver_id !== '0'}
                      value={ headerData.fee_waiver_id
                               ? (row.waiver_amt ?? "")           // editable
                                : formatAmount(row.waiver_amt)     // read-only
                          }
                      // onFocus={() => handleWaiverFocus(index)}
                      // onBlur={handleWaiverBlur}
                      //onBlur={(e) => handleWaiverBlur(index, e)}
                      onChange={(e) => handleWaiverChange(index, e)}
                    />
                  </td>

                </tr>

              ))}

            </tbody>
            <tfoot>
              <tr style={{ backgroundColor: '#f1f1f1' }}>
                <td colSpan="3" style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
                  Total Fees :
                </td>
                <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
                  <span style={{ paddingRight: '0px', display: 'inline-block' }}>
                    {new Intl.NumberFormat("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(totalFeeAmount)}
                  </span>
                </td>
                <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
                  <span style={{ paddingRight: '8px', display: 'inline-block' }}>
                    {new Intl.NumberFormat("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(totalFWAmount)}
                  </span>
                </td>
              </tr>
            </tfoot>

          </table>

        </div>

      </Card>

    </Container>
  );
};

export default FeesCollection;
